import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AboutLeadership, LasisiImg } from '../../assets/img';
// import { NavigationBar } from '../../components';
// import { Footer } from '../../components/footer';
import { Link } from 'react-router-dom';
import { profileBreadcrumb } from '../../components/main/products';
import { Screen } from '../../styles'


// const Navigation = NavigationBar.Navigation;
const App = () => {
  const [mobile, setMobile] = useState(false);
  const responsive = () => {
    window.innerWidth <= 900 ? setMobile(true): setMobile(false)
  }
  useEffect(() => {
    //Scroll to top on page load
    window.scrollTo(0, 0);

    responsive()
    window.addEventListener('resize', () => responsive())

    return () => {
      window.removeEventListener('resize', () => responsive())
    }
  }, []);
  return (
    <Box>
      {/* navigation */}
      {/* <Navigation /> */}
      {/* End of Navigation */}

      {/* Hero Section */}
      <Section className='hero'></Section>
      {/* End of hero section */}
      <BreadCrumb>
        {profileBreadcrumb.map(({ name, path }) => (
          <>
            <Links to={path}>{name}</Links> <span>/</span>
          </>
        ))}
      </BreadCrumb>

      {/* Profile section */}
      <Section>
        <Container>
          {
            mobile ? (
              <FlexBox>
                <div>
                <Header>Abiodun Lasisi</Header>
              <Title>HEAD, LOAN MONITORING & DEBT RECOVERY</Title>
                </div>
                <Image src={LasisiImg} alt='profile picture' />
                <Paragraph>
                <p>
                Lasisi brings a wealth of experience to his role as Head of Loan Monitoring 
                and Debt Recovery at Abbey Mortgage Bank. With a strong background in branch 
                banking operations, he has held various positions across different departments, 
                showcasing his versatility and expertise
              </p>
              <p>
                Lasisi's journey began in the banking sector, where he served as a front and back-office 
                officer at the Isolo and Ebute-Metta branches of a prominent bank. His dedication and proficiency 
                led him to the Yaba Branch, where he excelled as a Credit Monitoring and Loan Recovery Officer. 
                Notably, he also contributed as an instructor at the Union Bank Training School in Yaba, further 
                honing his skills in training and development.
            </p>
            <p>
              In 1994, Lasisi's exceptional performance earned him a secondment to the Inspection Department, 
              where he served as an Inspection Officer. During this time, he conducted thorough audits across 
              numerous branches and Head/Area Office Departments, demonstrating his attention to detail and commitment 
              to excellence.
            </p>
            <p>
              His journey continued in 1997 when he was appointed as the head of the Fraud Investigation and Prevention Unit, 
              where he played a pivotal role in investigating and presenting fraud cases for management consideration. His proactive 
              approach and strategic thinking significantly contributed to mitigating risks and safeguarding the bank's interests.
            </p>
            <p>
              Lasisi's areas of expertise include Estate Management, Mortgages, Micro-Finance activities, and, notably, Loan Monitoring & Debt Recovery. 
              His comprehensive understanding of these domains, coupled with his strategic acumen, makes him a valuable asset to Abbey Mortgage Bank's leadership team.
            </p>
                </Paragraph>
              </FlexBox>
            ): (
              <>
          <FlexBox>
            <Image src={LasisiImg} alt='profile picture' />
            <Content>
            <Header>Abiodun Lasisi</Header>
            <Title>HEAD, LOAN MONITORING & DEBT RECOVERY</Title>
              <p>
                Lasisi brings a wealth of experience to his role as Head of Loan Monitoring 
                and Debt Recovery at Abbey Mortgage Bank. With a strong background in branch 
                banking operations, he has held various positions across different departments, 
                showcasing his versatility and expertise
              </p>
              <p>
                Lasisi's journey began in the banking sector, where he served as a front and back-office 
                officer at the Isolo and Ebute-Metta branches of a prominent bank. His dedication and proficiency 
                led him to the Yaba Branch, where he excelled as a Credit Monitoring and Loan Recovery Officer. 
                Notably, he also contributed as an instructor at the Union Bank Training School in Yaba, further 
                honing his skills in training and development.
            </p>
            </Content>
          </FlexBox>
          <Content className='more'>
            <p>
              In 1994, Lasisi's exceptional performance earned him a secondment to the Inspection Department, 
              where he served as an Inspection Officer. During this time, he conducted thorough audits across 
              numerous branches and Head/Area Office Departments, demonstrating his attention to detail and commitment 
              to excellence.
            </p>
            <p>
              His journey continued in 1997 when he was appointed as the head of the Fraud Investigation and Prevention Unit, 
              where he played a pivotal role in investigating and presenting fraud cases for management consideration. His proactive 
              approach and strategic thinking significantly contributed to mitigating risks and safeguarding the bank's interests.
            </p>
            <p>
              Lasisi's areas of expertise include Estate Management, Mortgages, Micro-Finance activities, and, notably, Loan Monitoring & Debt Recovery. 
              His comprehensive understanding of these domains, coupled with his strategic acumen, makes him a valuable asset to Abbey Mortgage Bank's leadership team.
            </p>
          </Content>
              </>
            )
          }
        </Container>
      </Section>
      {/* End of profile section */}
      {/* Footer */}
      {/* <Footer /> */}
      {/* End of Footer */}
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
`;
const Section = styled.div`
  width: 100%;
  &.hero {
    min-height: 60vh;
    background-image: url(${AboutLeadership});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 80px;
    ${Screen.mediumpc`
    min-height: 40vh!important;
    `}
    ${Screen.smallpc`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
     ${Screen.tablet`
    min-height: 40vh!important;
    margin-top: 5rem!important;
    `}
     ${Screen.surfaceDuo`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.mediumPhone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.phone`
    min-height: 30vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.smallPhone`
    min-height: 30vh;
    margin-top: 5rem!important;
    `}
  }
`;
const Container = styled.div`
  width: 70%;
  margin: 5rem auto;
  ${Screen.miniLargeScreen`
  width: 80%;
  `}
  ${Screen.pad`
  width: 80%;
  `}
  ${Screen.mediumpc`
  width: 80%;
  `}
  ${Screen.smallpc`
  width: 70%;
  margin-bottom: 3rem
  `}
   ${Screen.tablet`
  width: 80%;
  margin-bottom: 3rem
  `}
  ${Screen.mediumPhone`
  width: 80%;
  margin-bottom: 3rem
  `}
  ${Screen.phone`
  width: 80%
  `}
  ${Screen.smallPhone`
  width: 80%
  `}
  ${Screen.galaxyFold`
  width: 90%
  `}
`;
const FlexBox = styled.div`
  display: flex;
  ${Screen.smallpc`
  flex-direction: column;
  `}
`;
const Image = styled.img`
width: 30%;
height: 380px;

${Screen.miniLargeScreen`
width: 300px;
height: 380px;
`}
${Screen.pad`
width: 300px;
height: 380px;
`}
${Screen.mediumpc`
width: 300px;
height: 380px;
`}
${Screen.smallpc`
width: 250px;
height: 280px;
margin: 2rem auto;
`}
${Screen.mediumPhone`
width: 70%;
height: 280px;
margin: 1rem auto;
`}
${Screen.phone`
width: 80%;
height: 250px;
margin: 1rem auto;
`}
${Screen.smallPhone`
width: 90%;
height: 250px;
margin: 1rem auto;
`}
${Screen.galaxyFold`
width: 80%;
height: 250px;
margin: 1rem auto;
`}
`;
const Content = styled.div`
  width: 50%;
  margin-left: 3rem;
  padding-top: 1.5rem;

  ${Screen.miniLargeScreen`
  padding-top: 0!important;
  `}

  p {
    word-spacing: 0.1rem;
    padding-top: 1rem;
  }

  &.more {
    width: 90%;
    margin-left: 0;
  }
`;
const Header = styled.h2`
  padding-bottom: 0.5rem;
  ${Screen.smallpc`
  text-align: center;
  font-size: 22px;
  `}
  ${Screen.mediumPhone`
  text-align: center;
  font-size: 22px;
  `}
  ${Screen.phone`
  text-align: center;
  font-size: 20px;
  `}
  ${Screen.smallPhone`
  text-align: center;
  font-size: 18px;
  `}
`;
const Title = styled.article`
${Screen.smallpc`
font-size: 12px;
text-align: center;
`}
${Screen.mediumPhone`
font-size: 12px;
text-align: center;
`}
${Screen.phone`
font-size: 12px;
text-align: center;
`}
${Screen.smallPhone`
font-size: 12px;
text-align: center;
`}
`;
const BreadCrumb = styled.div`
  width: 100%;
  height: 3rem;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  padding-left: 5rem;
  /* position: fixed; */

  span {
    font-weight: bold;
    padding-right: 0.5rem;
  }

  ${Screen.tablet`
  display: none;
  `}
`;
const Links = styled(Link)`
  color: #002668;
  text-decoration: none;
  font-weight: bold;
  padding-right: 0.3rem;
`;
const Paragraph = styled.div`
p {
  ${Screen.mediumPhone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
  ${Screen.phone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
  ${Screen.smallPhone`
  font-size: 14px;
  padding-bottom: 1rem;
  `}
   ${Screen.galaxyFold`
  font-size: 12px;
  padding-bottom: 1rem;
  `}
}
`;
export default App;
